import React from 'react';
import { QButton } from '@qualio/ui-components';
import * as DisplayStrings from '../../../../displayStrings';
import { useNavigate } from 'react-router-dom';

type HeaderCancelButtonProps = {
  eventId: number;
  stepId: number;
  formId: number;
  shouldShowEditViewButton: boolean;
  isDisabled: boolean;
};

export const HeaderCancelButton: React.FC<HeaderCancelButtonProps> = ({
  eventId,
  stepId,
  formId,
  shouldShowEditViewButton = false,
  isDisabled = false,
}) => {
  const navigate = useNavigate();

  return shouldShowEditViewButton ? (
    <QButton
      data-cy="cancel"
      variant="outline"
      isDisabled={isDisabled}
      onClick={() => navigate(`/events/${eventId}/steps/${stepId}/forms/${formId}`)}
    >
      {DisplayStrings.Cancel}
    </QButton>
  ) : null;
};
